module.exports = __webpack_public_path__ + "static/media/imgTwo.88abf3c9.jpg";